import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tv } from "../../lib/api/api";

const ChannelLogo = ({channel}) => {
    const [name, setName] = useState('');
    const [media, setMedia] = useState({});

    useEffect(() => {
        tv.channel(channel)
            .then((res) => {
                setName(res.name);
                setMedia(res.media.default);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [channel]);

    return (
        <>
            <li className="channel-description__logo-item">
                <Link className='channel-description__channel-link' to={`//telekarta.tv/tvprogram/channel/${channel}/`} target="_blank">
                    <img className="channel-description__channel-logo" src={media.url} width="40" height="40" alt={name}/>
                </Link>
            </li>
        </>
    );
};

export default ChannelLogo;